import React from 'react';
import styles from './MetricWithIcon.module.scss';

interface MetricWithIconProps {
  icon: string;
  title: string;
  legend?: string;
  metric: string;
}

const MetricWithIcon: React.FC<MetricWithIconProps> = ({
  icon,
  title,
  legend,
  metric,
}) => {
  return (
    <div className={styles.container}>
      <img src={icon} alt="Icon" className={styles.icon} />
      <div className={styles.text}>
        <div className="flex flex-column">
          <span className={styles.title}>{title}</span>
          <span className={styles.legend}>{legend}</span>
        </div>
        <span className={styles.metric}>{metric}</span>
      </div>
    </div>
  );
};

export default MetricWithIcon;
